import { Observable } from "rxjs";
import { DynamicRow } from "./dynamic-row.model";
import { DynamicValidation } from "./dynamic-validation";

export class DynamicTemplate<T> {
    data!: T;
    validators?: Array<DynamicValidation>;
    errorMessages!: Map<string, string>;
    rows?: Array<DynamicRow<T>>;

    constructor(source: Partial<DynamicTemplate<T>>) {
        Object.assign(this, source);
    }
}